import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';


import { MasterDataService } from 'src/app/core/services/http/master-data/master-data.service';
import { UserService } from 'src/app/core/services/user/user.service';
import { VerifyMobileNumberDialogComponent } from 'src/app/shared/components/verify-mobile-number-dialog/verify-mobile-number-dialog.component';
import { MasterDataTypeId } from 'src/app/shared/configs/master-data-type-id.config';

@Component({
  selector: 'app-todo-dialogue',
  templateUrl: './todo-dialogue.component.html',
  styleUrls: ['./todo-dialogue.component.scss']
})
export class TodoDialogueComponent {
  
  userToDoData : any;
  rrTypeList: any;
  loadingOnSave: boolean = false;
  bypassMobile: any;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {summary : any, bypassCount : number, details: any},
    private router: Router,
    private matDialogRef: MatDialogRef<TodoDialogueComponent>,
    private matDialog: MatDialog,
    private userService: UserService,
    private masterService: MasterDataService
  ){
    this.masterService?.fetchMasterDataById({ type_id: MasterDataTypeId.rrType })?.pipe()?.
    subscribe(res => {
        this.rrTypeList = res.data.filter((obj) => obj.name === "Monthly Closure")[0];
      });
  }

  onClickButton(element : any): void {
    // this.userService.getToDoDetails$().subscribe((res) =>  {
    //   this.userToDoData = res
    // })
    // this.userToDoData.isPending = false;
    // this.userService.setToDoDetails$(this.userToDoData);
    this.matDialog.closeAll();
    this.userService.setTODODialogState(false);
    if(element.code==="Monthly_Closure_RR"){
      let grnParams = {"centerID":null,"RRTypeID":this.rrTypeList.id,"statusID":null,"userType":null,"search":null,"ticketNumber":null,"rrSubTypeId":null}
      this.router.navigate(['nephroplus/rrs/report'], {queryParams: {
        filter: JSON.stringify(grnParams)
      }});
    }
    if(element.code === "Daily_Report"){
      this.router.navigate(['nephroplus/operations/daily-report/create'])
    }
    if(element.code === "DAILY_QUALITY_REPORT"){
      this.router.navigate(['nephroplus/quality/daily-quality-report/add'])
    }
    if(element.code === "GRN_TR"){
      let params = {"centerId": Object.keys(this.data.details)[0]}
      this.router.navigate(['nephroplus/scm/transfers-list'], {queryParams: {
        filter: JSON.stringify(params)
      }})
    }
    if(element.code === "GRN_PO"){
      let params = {"centerId": Object.keys(this.data.details)[0]}
      this.router.navigate(['nephroplus/scm/purchase-orders'], {queryParams: {
        filter: JSON.stringify(params)
      }})
    }
  }

  onClickBypass():void {
    this.loadingOnSave = true;
     this.masterService.sendToDoOtp().subscribe(
      (res) => {
        this.bypassMobile = res?.data.manager_phone;

        const dialogRef = this.matDialog.open(VerifyMobileNumberDialogComponent, {
          data: {
            isAbhaVerification: false,
            isOtpVerification: true,
            mobileNumber: this.bypassMobile,
            isChangeMobile: false,
          },
        });
        
        dialogRef.afterClosed().subscribe(response => {
          if(response === true){
            this.matDialog.closeAll();
            this.userService.setToDoOpen(false);
            // this.matDialogRef.close(true);
          }
        })
      }
    );
    
   
  }
}
